import React from 'react';

import { devLog } from '../utils/devLog';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    devLog.error('Application error:', error, errorInfo);
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // If a custom fallback render prop is provided, use it
      if (this.props.fallback) {
        return this.props.fallback({
          error: this.state.error,
          resetError: () => this.setState({ hasError: false, error: null, errorInfo: null }),
        });
      }

      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'sans-serif', padding: '2rem' }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1a1a1a' }}>Something went wrong</h1>
          <p style={{ color: '#666', marginBottom: '1.5rem' }}>Please try refreshing the page.</p>
          {this.state.error && (
            <pre style={{
              background: '#f5f5f5', padding: '1rem', borderRadius: '0.5rem',
              maxWidth: '600px', overflow: 'auto', fontSize: '0.75rem', color: '#c00',
              marginBottom: '1rem', textAlign: 'left', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            }}>
              {this.state.error.toString()}
              {this.state.errorInfo?.componentStack && (
                '\n\nComponent Stack:' + this.state.errorInfo.componentStack.split('\n').slice(0, 8).join('\n')
              )}
            </pre>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '0.5rem 1.5rem', backgroundColor: '#B40A0A', color: 'white', border: 'none', borderRadius: '0.375rem', cursor: 'pointer', fontSize: '1rem' }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
